import { EmploymentService } from "../../services";
import { createCRUDThunksLegacy } from "../../shared/helpers";
import { EmploymentRequest, EmploymentResponse } from "../../shared/types";

const service = new EmploymentService();

const basicThunks = createCRUDThunksLegacy<
  EmploymentResponse,
  EmploymentRequest
>({
  service,
  resourceName: "employments",
});

export const EmploymentThunks = {
  ...basicThunks,
};
